<template>
  <div id="app" class="main-container">
    <GlobalLoading v-if="
      $store.state.modalStore.isGlobalLoading || $store.state.level1.isLoading
    " />
    <Navbar />
    <AdvanceSearch v-if="$store.state.searchStore.showModal" />
    <Login v-if="$store.state.showModalLogin" />
    <Forgot v-if="$store.state.showModalForgot" />
    <Reset v-if="$store.state.showModalReset" />
    <Notif v-if="$store.state.showModalNotif" />
    <!-- Content -->
    <div>
      <div>
        <router-view />
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Navbar from '@/components/utils/Navbar-v2'
import Footer from '@/components/utils/footer'
import { api } from '@/services/config'
import axios from 'axios'

export default {
  head: {
    link: [
      {
        rel: 'stylesheet',
        href: 'https://fonts.googleapis.com/icon?family=Material+Icons',
      },
    ],
  },
  components: {
    GlobalLoading: () => import('@/components/V2/GlobalLoading.vue'),
    Navbar,
    Footer,
    AdvanceSearch: () => import('@/components/modal/advanceSearch.vue'),
    Login: () => import('@/components/modal/Login.vue'),
    Forgot: () => import('@/components/modal/forgot.vue'),
    Reset: () => import('@/components/modal/reset.vue'),
    Notif: () => import('@/components/modal/Notification.vue'),
  },
  async created() {
    this.$store.commit('AUTO_LOGIN')
    if (this.$store.state.token) {
      this.runLogin()
    }
  },
  mounted() {
    this.$gtag.pageview({
      page_title: 'Home',
      page_path: this.$route.path,
      page_location: window.location.href,
      role: this.$store.state.role_id,
      user: this.$store.state.userid,
    })
  },
  methods: {
    async runLogin() {
      const url = `${api}/api/v1/auth/permissions/${this.$store.state.userid}`

      this.$store.commit('modalStore/SET_GLOBAL_LOADING', true)
      try {
        const { data: auth } = await axios({
          method: 'GET',
          url,
          headers: {
            authorization: `Bearer ${this.$store.state.token}`,
          },
        })

        if (auth && auth.data) {
          this.$store.commit('SET_TOKEN', auth.data.token)
          this.$store.commit('SET_PERMISSIONS', auth.data.permission)
          if (auth.data.kode && auth.data.kode.length > 0) {
            this.$store.commit('SET_KODE', auth.data.kode)
          }
          this.$store.commit('SET_MODAL_LOGIN', false)
          this.$store.commit('modalStore/SET_GLOBAL_LOADING', false)
          this.$store.commit('AUTO_LOGIN')
        }
      } catch (error) {
        this.$store.commit(
          'SET_NOTIF',
          this.$get(error, 'response.data.message', 'Server Error')
        )
        this.$store.commit('modalStore/SET_GLOBAL_LOADING', true)
        this.$store.commit('modalStore/SET_GLOBAL_LOADING', false)
      }
    },
  },
}
</script>
